import { Component, Input, Output, EventEmitter } from '@angular/core';
import { VernostService } from '../../services/app.service';

@Component({
  selector: 'vernost-search',
  templateUrl: './vernost-search.html',
  styleUrls: ['./vernost-search.scss'],
  providers: [VernostService]
})

export class VernostSearchComponent {

  @Input('searchtitle') searchtitle: string;
  @Input('searchModel') searchModel: any;
  inProgress:boolean=false;

  constructor(private mainService: VernostService) {

  }

  ngOnInit() {

  }

  @Output() showScreen = new EventEmitter<string>();

  onAddClick() {
    this.showScreen.emit();
  }

  @Output() searchdata:EventEmitter<any>= new EventEmitter<any>();

  onSearchClick() {
    this.inProgress=true;
    this.mainService.postData('/searchfilter', this.searchModel).subscribe(
      (response: any) => {
        // console.log("onSearchClick response === ",response);
        this.inProgress=false;
        this.searchdata.emit(response);
      });
  }

}
